module.exports = __webpack_public_path__ + "static/media/img_9.06f6a268.png";